var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { inject, observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import * as React from 'react';
import { getPropertyOffersInput } from 'stores/adapters/bex-api/property-info/property-info-input-adapter';
import { parse } from 'query-string';
export const withSharedUiPropertyOffers = SharedUiWrapper => {
  const PropertyOffersComponent = inject('currentHotel', 'context', 'multiItem')(observer(_a => {
    var _b;
    var {
        currentHotel,
        context,
        multiItem
      } = _a,
      props = __rest(_a, ["currentHotel", "context", "multiItem"]);
    const location = useLocation();
    const urlParameters = parse(location.search);
    const {
      dateless,
      startDate,
      chkin,
      d1
    } = urlParameters;
    const isDatedPdp = Boolean(!dateless && (startDate || chkin || d1));
    const datesAreGoingToBeHydrated = isDatedPdp && !(currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.searchCriteria.startDate);
    if (!context || !(currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.searchCriteria) || !currentHotel.hotelId || datesAreGoingToBeHydrated) {
      return null;
    }
    const inputs = getPropertyOffersInput(context, currentHotel, urlParameters, (_b = multiItem === null || multiItem === void 0 ? void 0 : multiItem.multiItemContext) !== null && _b !== void 0 ? _b : undefined);
    return React.createElement(SharedUiWrapper, Object.assign({
      inputs: inputs
    }, props));
  }));
  PropertyOffersComponent.displayName = 'PropertyOffersComponent';
  return PropertyOffersComponent;
};